
import React,{useState} from "react";

const FileValidations = ()=>{
    const [fileError,setFileError] = useState({})
    const fileTypes= ['image/jpeg','image/png','image/jpg']
    
    const CheckFile = async (files, name) => {
        if (!files) {
            console.warn('No file provided to CheckFile');
            return;
        }

        try {
            // Add a small delay for mobile devices
            await new Promise(resolve => setTimeout(resolve, 50));
            
            const size = files.size / 1024 / 1024;
            console.log(`File size: ${size}MB for ${name}`);
            
            if (size > 50) {
                setFileError((prev) => ({
                    ...prev,
                    [name]: {
                        message: "File should not be greater than 50 MB",
                    },
                }));
            } else {
                // Clear any existing error for this field
                setFileError((prev) => {
                    const { [name]: removedField, ...rest } = prev;
                    return rest;
                });
            }
        } catch (error) {
            console.error('Error in CheckFile:', error);
            setFileError((prev) => ({
                ...prev,
                [name]: {
                    message: "Error processing file",
                },
            }));
        }
    }
    
    return {
        CheckFile,
        fileError
    }
}

export default FileValidations
 